var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"asterika-video flex"},[_c('div',{staticClass:"asterika-video__player asterika-video__player--full"},[_c('video',{attrs:{"src":"/apppreview-asterika.webm","autoplay":"","muted":"","playsinline":"","loop":""},domProps:{"muted":true}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }